import { css } from 'linaria';

export const collectionComposition = css`
  && {
    border: 1px solid #e8e9eb;
    border-radius: var(--rounding-l);
  }
`;

export const collectionCompositionHeader = css`
  display: flex;
  padding: 29px 45px;
  column-gap: 27px;
  background-color: var(--background-secondary);

  @media (--only-desktop) {
    padding: 24px 40px;
    column-gap: 22px;
  }

  @media (--only-tablet) {
    padding: 16px 26px;
    column-gap: 16px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    row-gap: 16px;
    padding: 24px;
  }
`;

export const collectionCompositionHeaderIcon = css``;

export const collectionCompositionHeaderText = css`
  display: flex;
  flex-direction: column;
  width: 927px;
  row-gap: 6px;

  @media (--only-desktop) {
    width: 749px;
  }

  @media (--only-tablet) {
    width: 533px;
    row-gap: 4px;
  }

  @media (--only-mobile) {
    width: 100%;
    row-gap: 8px;
  }
`;

export const collectionCompositionContent = css`
  display: flex;
  padding: 56px 118px;
  column-gap: 85px;

  @media (--only-desktop) {
    padding: 44px 93px;
    column-gap: 70px;
  }

  @media (--only-tablet) {
    padding: 32px 58px;
    column-gap: 50px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    padding: 24px;
    row-gap: 24px;
  }
`;

export const collectionCompositionImage = css`
  width: 400px;
  height: 400px;

  @media (--only-desktop) {
    width: 318px;
    height: 318px;
  }

  @media (--only-tablet) {
    width: 230px;
    height: 230px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 100%;
  }
`;

export const collectionCompositionTextWrapper = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 20px;

  @media (--only-desktop) {
    row-gap: 16px;
  }

  @media (--only-tablet) {
    row-gap: 12px;
  }
`;

export const collectionCompositionTextRow = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 15px;

  @media (--only-desktop) {
    row-gap: 12px;
  }

  @media (--only-tablet) {
    row-gap: 8px;
  }

  @media (--only-tablet) {
    row-gap: 10px;
  }
`;

export const collectionCompositionText = css`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column;
    row-gap: 8px;
  }
`;

export const collectionCompositionName = css`
  @media (--only-desktop) {
    width: 310px;
  }

  @media (--only-tablet) {
    width: 220px;
  }
`;
